
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PostEditor from "@/components/PostEditor";
import { useBlogModule } from "./useBlogModule";
import BlogHeader from "./BlogHeader";
import BlogFilters from "./BlogFilters";
import BlogList from "./BlogList";
import BlogOverview from "./BlogOverview";
import BlogSettings from "./BlogSettings";

const BlogModule: React.FC = () => {
  const {
    isLoading,
    posts,
    searchTerm,
    setSearchTerm,
    viewMode,
    setViewMode,
    tabFilter,
    setTabFilter,
    editingPostId,
    isCreatingPost,
    isDeleting,
    loadPosts,
    handleEditPost,
    handleCreatePost,
    handleCancelEdit,
    handleViewPost
  } = useBlogModule();
  const [activeTab, setActiveTab] = useState("overview");

  // If in edit mode, show post editor
  if (editingPostId !== undefined) {
    return (
      <div className="min-h-screen p-6">
        <PostEditor 
          postId={editingPostId}
          onCancel={handleCancelEdit}
        />
      </div>
    );
  }

  // If in create mode, show post editor without a post ID
  if (isCreatingPost) {
    return (
      <div className="min-h-screen p-6">
        <PostEditor 
          onCancel={handleCancelEdit}
        />
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">
      <BlogHeader onCreatePost={handleCreatePost} />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="h-auto w-full justify-start gap-2 rounded-xl bg-slate-100 p-1">
          <TabsTrigger value="overview" className="flex-1 rounded-lg px-4 py-2 text-sm font-medium data-[state=active]:bg-white data-[state=active]:shadow">
            Visão geral
          </TabsTrigger>
          <TabsTrigger value="posts" className="flex-1 rounded-lg px-4 py-2 text-sm font-medium data-[state=active]:bg-white data-[state=active]:shadow">
            Posts
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex-1 rounded-lg px-4 py-2 text-sm font-medium data-[state=active]:bg-white data-[state=active]:shadow">
            Configurações & SEO
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <BlogOverview posts={posts} loading={isLoading} onCreatePost={handleCreatePost} />
        </TabsContent>

        <TabsContent value="posts" className="space-y-6">
          <BlogFilters
            searchTerm={searchTerm}
            viewMode={viewMode}
            tabFilter={tabFilter}
            onSearchChange={setSearchTerm}
            onViewModeChange={setViewMode}
            onTabFilterChange={setTabFilter}
          />

          <BlogList
            posts={posts}
            viewMode={viewMode}
            searchTerm={searchTerm}
            tabFilter={tabFilter}
            isLoading={isLoading}
            isDeleting={isDeleting}
            onEditPost={handleEditPost}
            onViewPost={handleViewPost}
            onSetViewMode={setViewMode}
            onSearchChange={setSearchTerm}
            onFilterChange={setTabFilter}
            onLoadPosts={loadPosts}
          />
        </TabsContent>

        <TabsContent value="settings">
          <BlogSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default BlogModule;
